export const CNP_PAYMENT_STATUS_FAILED = 'Failed';
export const CNP_PAYMENT_STATUS_SUCCESS = 'Success';
